/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import './Notifications.css'
import { fetchNotifications, MarkAsRead } from '../../features/auth/notificationSlice'
import { useAppDispatch } from '../../hooks/reduxHooks'
import { formatNotificationTime } from '../../app/helper/DateHelper'
import { useNavigate } from 'react-router-dom'
import { deleteNotification } from '../../services/partnerService'
import { toast } from 'react-toastify'

const Notifications = () => {
  const dispatch = useAppDispatch()
  const notifications = useSelector((state: RootState) => state.notifications.notifications)
  const navigate = useNavigate()
  const [search, setSearch] = useState("")

  const { partnerId } = useSelector((state: RootState) => state.auth);

  const unreadCount = notifications.filter((n) => !n.isRead).length

  const handleMarkAllRead = () => {
    if (partnerId) {
      dispatch(MarkAsRead(partnerId))
    }
  }
  const handleDeleteNotify = async (id: string) => {
    try {

      const response = await deleteNotification(id)
      console.log("show response--->", response);
      if (response.success) {
        toast.success(response?.message || "Delete notification successfully")
      }
      if (partnerId) {
        dispatch(fetchNotifications({ userId: partnerId, search }))
      }

    } catch (error) {
    console.log("error:",error);
    
    }
  }

  const IconTrash = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M3 6h18" />
      <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
      <path d="M10 11v6" />
      <path d="M14 11v6" />
    </svg>
  );

  const getNotifications = async()=>{
    if(partnerId){
      dispatch(fetchNotifications({userId:partnerId,search}));
    }
  }
  
  useEffect(()=>{
    getNotifications()
  }, [search, partnerId, dispatch])

  return (
    <div className="notif-page">
      <div className="notif-page__container">
        <div className="notif-page__header">
          <div className="">
            <h1 className="dash-hero__title">Notifications</h1>
            {unreadCount > 0 && (  
              <span className="notif-page__badge">{unreadCount} new</span>
            )}
          </div>   

          {notifications.length > 0 && (
            <button
              type="button"
              className="notif-page__mark-read"
              onClick={handleMarkAllRead}
              disabled={unreadCount === 0}
            >
              Mark all as read
            </button>
          )}
        </div>

        <div className="notif-page__search-wrap">
          <span className="notif-page__search-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
              <circle cx="11" cy="11" r="8" />
              <path d="M21 21l-4.35-4.35" />
            </svg>
          </span>
          <input
            type="text"
            className="notif-page__search"
            placeholder="Search notifications…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="notif-page__list">
          {notifications.length === 0 ? (
            <div className="notif-page__empty">
              <p>No notifications yet</p>
              <span>New updates will show up here</span>
            </div>
          ) : (
            notifications
              .filter((n) =>
                n.title?.toLowerCase().includes(search.toLowerCase()) ||
                n.message?.toLowerCase().includes(search.toLowerCase())
              )
              .map((n) => (
                <div
                  key={n._id}
                  className={`notif-item ${!n.isRead ? 'notif-item--unread' : ''}`}
                //   onClick={} 
                >
                  <span className="notif-item__dot" />
                  <div className="notif-item__content">
                    <p className="notif-item__title">{n.title}</p>
                    <p className="notif-item__message">{n.message}</p>
                  </div>
                  <span className="notif-item__time">
                    {formatNotificationTime(n?.createdAt!)}
                  </span>
                  <button
                    type="button"
                    className="notif-item__delete "
                    title="Delete notification"
                    onClick={(e) => {
                      e.stopPropagation()

                      handleDeleteNotify(n._id!)

                    }}
                  >
                    <IconTrash />
                  </button>
                </div>
              ))
          )}
        </div>
      </div>
    </div>
  )
}

export default Notifications